export default __webpack_public_path__ + "static/Logo-fb6ee854e638d3ef19b5142c627fc52d.png";